import React from 'react';

function Home() {
  return (
    <section id="home">
      <h1>Welcome to CONNECT ALL (SL) LTD</h1>
      <p>Your trusted partner in professional consulting and business solutions.</p>
    </section>
  );
}

export default Home;
